import script from "./ShareholderDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareholderDetailModal.vue?vue&type=style&index=0&id=4f08f82a&lang=css"
import "./ShareholderDetailModal.vue?vue&type=style&index=1&id=4f08f82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f08f82a"]])

export default __exports__